// Minimal landing page shown from the login screen.
import React from 'react';
import { Box, Button, Container, Grid, Paper, Typography } from '@mui/material';

const highlights = [
  { title: 'Digital profile', text: 'One shareable profile page for you or your whole team.' },
  { title: 'QR codes & wallet passes', text: 'Business-card QR codes and Apple / Google wallet passes.' },
  { title: 'Email signatures & ID cards', text: 'Consistent signatures and printable ID cards in a click.' },
];

export const KoorAILandingPage = ({ onLoginClick }) => (
  <Box sx={{ minHeight: '100vh', bgcolor: '#f5f7fa', py: 10 }}>
    <Container maxWidth="md">
      <Typography variant="h3" fontWeight={700} gutterBottom>
        KoorAI Profile Manager
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph>
        Manage professional profiles, QR codes, email signatures and ID cards in one place.
      </Typography>
      <Button variant="contained" size="large" onClick={onLoginClick} sx={{ mb: 6 }}>
        Sign in
      </Button>
      <Grid container spacing={3}>
        {highlights.map((h) => (
          <Grid item xs={12} md={4} key={h.title}>
            <Paper sx={{ p: 3, height: '100%' }} variant="outlined">
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>{h.title}</Typography>
              <Typography variant="body2" color="text.secondary">{h.text}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default KoorAILandingPage;
